// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18578d2c","239":"312a8311","455":"4b60d45f"}[chunkId] + ".chunk.js";
};